import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/components/news/NewsContent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(site)/components/news/newsDetail.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/components/news/NewsImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/components/news/RelatedFeaturedImage.tsx");
